export default "__VITE_ASSET__DCM_9QQx__"